export default "__VITE_ASSET__Bs_og05t__"